import  api from './api.js'

export default {
  configurarEnvioEmail(dados){
    return api().post('/checkinpay/config/email', dados)
  },
  recuperarDadosConfiguracaoEmail(id){
    return api().get('/checkinpay/config/email', {params: {idusuario: id}})
  }
}